/* Triggering toasts from a reducer is little bit nasty, but this way we have one
 * central point where all toasts get triggered. The 'right' way to do it is to trigger
 * them in actions as demonstrated here: https://codesandbox.io/s/2485wxy78j .
 * (Please refactor it whenever that seems more appropriate.) Edit: @TODO The data actions already
 * have been rewritten to trigger toasts from them, this should be done for login as well
 */

import { CarFileViewTypeEnum } from 'config/enums'
import { storageKeys } from 'config/storage'
import i18next from 'i18next'
import { types as authTypes } from 'redux/actions/auth'
import { types as uiTypes } from 'redux/actions/ui'
import storage from 'utilities/storage'
import toast from 'utilities/toast'

let timeoutId
let loadingToastId

// The stock view (standard/sales/...) chosen in this tab survives a page reload,
// the salesView setting from the backend is only the default for a new tab
const storedStockViewType = storage.getSession(storageKeys.STOCK_VIEW_TYPE)

const isSalesView = (stockViewType) =>
  stockViewType === CarFileViewTypeEnum.SALES

const getStockViewType = (salesView) =>
  salesView ? CarFileViewTypeEnum.SALES : CarFileViewTypeEnum.STANDARD

export const initialState = {
  imageOverlayOpen: false,
  imagesSetType: null, // ImageSetTypeEnum - 'regular-car-file' or 'b2b-car-file'
  imageOverlayImageIdx: 0,
  carouselImages: null,
  salesView: storedStockViewType ? isSalesView(storedStockViewType) : true,
  salesViewInitialized: false,
  stockViewType: storedStockViewType || null,
  searchbox: false,
  carFileChecklistProgressNeedsUpdate: false,
  toasts: {
    infos: [],
    warnings: [],
    errors: [],
  },
}

const withStockViewType = (state, stockViewType) => {
  storage.setSession(storageKeys.STOCK_VIEW_TYPE, stockViewType)

  return {
    ...state,
    stockViewType,
    salesView: isSalesView(stockViewType),
  }
}

export function reducer(state = initialState, action) {
  const { status, payload, type } = action

  switch (type) {
    case uiTypes.OPEN_IMAGE_OVERLAY: {
      return {
        ...state,
        imageOverlayOpen: true,
        imageOverlayImageIdx: payload.imageIdx,
        imagesSetType: payload.imagesSetType,
        carouselImages: payload.images,
      }
    }

    case uiTypes.CLOSE_IMAGE_OVERLAY: {
      return {
        ...state,
        imageOverlayOpen: false,
      }
    }

    case uiTypes.TOGGLE_SALES_VIEW: {
      return withStockViewType(state, getStockViewType(!state.salesView))
    }

    case uiTypes.SET_SALES_VIEW: {
      return withStockViewType(state, getStockViewType(payload.value))
    }

    case uiTypes.SET_STOCK_VIEW_TYPE: {
      return withStockViewType(state, payload.viewType)
    }

    case uiTypes.CLOSE_SEARCHBOX: {
      return {
        ...state,
        searchbox: false,
      }
    }

    case uiTypes.OPEN_SEARCHBOX: {
      return {
        ...state,
        searchbox: true,
      }
    }
    case uiTypes.OPEN_OVERLAY: {
      return {
        ...state,
        overlay: {
          id: payload.type,
          props: payload.props,
        },
      }
    }

    case uiTypes.CLOSE_OVERLAY: {
      return {
        ...state,
        overlay: null,
      }
    }

    case authTypes.SET_LOGIN: {
      if (status === 'REQUEST') {
        timeoutId = setTimeout(() => {}, 100)
      }
      if (status === 'SUCCESS') {
        clearTimeout(timeoutId)
        toast.dismiss(loadingToastId)
        toast.success(i18next.t('successfullyLoggedIn'))
      }
      if (status === 'FAILURE') {
        clearTimeout(timeoutId)
        toast.dismiss(loadingToastId)
        toast.error(i18next.t('failedToLogin'))
      }

      return state
    }

    case authTypes.SET_LOGOUT: {
      if (status === 'SUCCESS') {
        storage.removeSession(storageKeys.STOCK_VIEW_TYPE)
        return {
          ...state,
          salesView: true,
          salesViewInitialized: false,
          stockViewType: null,
        }
      }

      return state
    }

    case authTypes.SET_VERIFY_AUTH: {
      if (status === 'SUCCESS' && !state.salesViewInitialized) {
        const stockViewType =
          storage.getSession(storageKeys.STOCK_VIEW_TYPE) ||
          getStockViewType(payload.userDetails.salesView)

        return {
          ...state,
          salesView: isSalesView(stockViewType),
          stockViewType,
          salesViewInitialized: true,
        }
      }

      return state
    }

    case uiTypes.CAR_FILE_CHECKLIST_PROGRESS_NEEDS_UPDATE: {
      return {
        ...state,
        carFileChecklistProgressNeedsUpdate: payload.update,
      }
    }

    case uiTypes.SET_SELECTED_LOCATION_ID: {
      return {
        ...state,
        selectedLocationId: payload.id,
      }
    }

    default:
      return state
  }
}
